import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { LeadActivityTabsComponent } from 'src/app/private/components/leads/lead-activity-tabs/lead-activity-tabs.component';
import { LeadStatusComponent } from 'src/app/private/components/leads/lead-status/lead-status.component';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { DatePickerModule } from 'primeng/datepicker';
import { Calendar } from 'primeng/calendar';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService } from 'primeng/api';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { RegistrationStatusComponent } from "../../registration/registration-status/registration-status.component";
import { ApplicationStatusComponent } from "../../application/application-status/application-status.component";
import { catchError, forkJoin, of } from 'rxjs';
import { EnrollmentStatusComponent } from "../../enrollment/enrollment-status/enrollment-status.component";
@Component({
  selector: 'app-lead-profile-middle-screen',
  imports: [TabsModule, LeadStatusComponent, FormsModule, InputTextModule,
    DividerModule, TextareaModule, SelectModule, LeadActivityTabsComponent, SharedModule, DatePickerModule, RegistrationStatusComponent, ApplicationStatusComponent, EnrollmentStatusComponent],
  templateUrl: './lead-profile-middle-screen.component.html',
  styleUrl: './lead-profile-middle-screen.component.scss'
})
export class LeadProfileMiddleScreenComponent {
  today: Date = new Date();
  createFieldFormValue: any = {};
  previousLeadData: any = {};
  isSubmitted: boolean = false;
  fieldValues: { [key: string]: any } = {};

  @ViewChild('dobPicker') dobPicker!: Calendar;
  @Output() handleUpdateData = new EventEmitter<any>();

  @Input() fullUserList: any = [];
  @Input() fullCourseList: any = [];

  @Input() paymentForList: any = [];

  openDatePicker() {
    this.dobPicker.overlayVisible = true;
  }

  closeDatePicker() {
    this.dobPicker.overlayVisible = false;
  }

  @Input() allLeadFeilds: any = [];
  @Input() editLeadData: any = {};
  @Input() editType: any = {};

  @Input() users = [];

  activeTab: number | string = -1;

  accessObject: any = {};
  
  isLoading: boolean = false;
  @Input() allCourses: any = [];

  constructor(private api: LeadService, private localStorage: LocalStorageService, private messageService: MessageService,
    private leadActivityService: LeadActivityService, private router: Router
  ) { 

    this.accessObject = this.localStorage.checkCRUDAccess('lead', 'manual');

    console.log("Access Object: ", this.accessObject.isMoveToRegistrationAccess);
  }

  ngOnInit() {
    this.createFieldFormValue = this.editLeadData;
    this.fieldValues = this.editLeadData.dynamic_fields || {};
    this.previousLeadData = JSON.parse(JSON.stringify(this.editLeadData));

    console.log("allLeadFeilds", this.allLeadFeilds);
    
    // Only load pipelines if editType is 'leads'
    if (this.editType === 'leads') {
      this.loadPipelineStages();
    } else {
      // For other editTypes, set loading to false immediately
      this.isPipelineLoading = false;
    }
  }


  leadSources: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];

  leadTypes: any[] = [
    { label: 'New Lead', value: 'New Lead' },
    { label: 'Cold Lead', value: 'Cold Lead' },
    { label: 'Warm Lead', value: 'Warm Lead' },
    { label: 'Hot Lead', value: 'Hot Lead' }
  ];

  leadStatusList: any[] = [];
  pipelineStages: any[] = [];
  selectedDefaultPipelineId: any = null;
  isPipelineLoading: boolean = true;

  queryTypes: any[] = [
    { label: 'General', value: 'General' },
    { label: 'Admission', value: 'Admission' },
    { label: 'Application', value: 'Application' },
    { label: 'Fee Structure', value: 'Fee Structure' },
    { label: 'Registration', value: 'Registration' },
    { label: 'Placement', value: 'Placement' },
    { label: 'Alumni', value: 'Alumni' },
    { label: 'Course', value: 'Course' },
    { label: 'Other', value: 'Other' }
  ];

  genderOptions: any[] = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  prefixOptions: any[] = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Dr', value: 'Dr' },
    { label: 'Prof', value: 'Prof' }
  ];


  documentStatusList = [
    { label: 'Verified', value: 'verified' },
    { label: 'Pending', value: 'pending' },
    { label: 'Rejected', value: 'rejected' }
  ];

  registrationStatusList: any[] = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Accepted', label: 'Accepted' },
    { value: 'Rejected', label: 'Rejected' }
  ];


  applicationStatusList: any[] = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  enrollmentStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  modeOfStudyOptions: any[] = [
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
    { label: 'Hybrid', value: 'Hybrid' }
  ];

  paymentStatusList = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Failed', value: 'Failed' }
  ];

  paymentModeList = [
    { label: 'Cash', value: 'Cash' },
    { label: 'Credit Card', value: 'Credit Card' },
    { label: 'Debit Card', value: 'Debit Card' },
    { label: 'Bank Transfer (NEFT/RTGS/IMPS)', value: 'Bank Transfer' },
    { label: 'Cheque', value: 'Cheque' },
    { label: 'UPI (Google Pay / PhonePe / Paytm)', value: 'UPI' },
    { label: 'Net Banking', value: 'Net Banking' },
    { label: 'Demand Draft', value: 'Demand Draft' },
    { label: 'Wallet', value: 'Wallet' },
    { label: 'Other', value: 'Other' }
  ];


  isFixedColumn: boolean = true;

  @Input() selectedTabIdx: number = 0;

  @Output() changeTab = new EventEmitter<number>();

  loadPipelineStages() {
    this.isPipelineLoading = true;
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      pipeline_type: 'lead'
    };
    this.api.getAllPipelines(param).subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          // find set_default true pipeline id
          const defaultPipeline = res.find((pipeline: any) => pipeline.set_default === true);
          if (defaultPipeline) {
            this.selectedDefaultPipelineId = defaultPipeline.id;
          }
          this.pipelineStages = res.map((pipeline: any) => ({
            label: pipeline.pipeline_name,
            value: pipeline.id,
            stages: pipeline.stages
          }));
          
          // Load stages for the default or current pipeline
          if (this.editLeadData?.pipeline_id) {
            const currentPipeline = this.pipelineStages.find(p => p.value === this.editLeadData.pipeline_id);
            this.leadStatusList = currentPipeline?.stages || [];
          } else if (this.selectedDefaultPipelineId) {
            const defaultPipe = this.pipelineStages.find(p => p.value === this.selectedDefaultPipelineId);
            this.leadStatusList = defaultPipe?.stages || [];
          }
        }
        this.isPipelineLoading = false;
      },
      error: (e: any) => {
        console.error('Error loading pipeline stages:', e);
        this.isPipelineLoading = false;
      },
    });
  }

  get leadStatusValues(): string[] {
    return this.leadStatusList.map(s => s.stage_name || s.value);
  }

  onPipelineChange(event: any) {
    const selectedPipelineId = event.value;
    if (selectedPipelineId && this.pipelineStages && this.pipelineStages.length > 0) {
      const selectedPipeline = this.pipelineStages.find(p => p.value === selectedPipelineId);
      this.leadStatusList = selectedPipeline?.stages || [];
      
      // Reset lead status and score when pipeline changes
      this.createFieldFormValue['lead_status'] = '';
      this.createFieldFormValue['lead_score'] = null;
    }
  }

  onStatusChange(event: any) {
    const selectedStatusName = event.value;
    if (selectedStatusName && this.leadStatusList && this.leadStatusList.length > 0) {
      const selectedStage = this.leadStatusList.find((stage: any) => stage.stage_name === selectedStatusName);
      if (selectedStage && selectedStage.score !== undefined) {
        this.createFieldFormValue['lead_score'] = selectedStage.score;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editLeadData'] && changes['editLeadData'].currentValue != changes['editLeadData'].previousValue) {
      this.createFieldFormValue = this.editLeadData;
      this.fieldValues = this.editLeadData.dynamic_fields || {};
      this.previousLeadData = JSON.parse(JSON.stringify(this.editLeadData));
      this.createFieldFormValue.reg_data = this.editLeadData.registration;
      this.createFieldFormValue.date_of_birth = this.editLeadData.date_of_birth ? new Date(this.editLeadData.date_of_birth) : null;

      // Initialize pipeline data
      if (!this.createFieldFormValue.pipeline_id && this.selectedDefaultPipelineId) {
        this.createFieldFormValue.pipeline_id = this.selectedDefaultPipelineId;
      }
      if (this.createFieldFormValue.pipeline_id) {
        const currentPipeline = this.pipelineStages.find(p => p.value === this.createFieldFormValue.pipeline_id);
        if (currentPipeline) {
          this.leadStatusList = currentPipeline.stages || [];
        }
      }

      if (this.editType == 'application') {
        this.createFieldFormValue.application_data = this.editLeadData.application_data || {};
        this.createFieldFormValue.application_data.course_id = parseInt(this.createFieldFormValue.application_data.course_id || 0);
        console.log("this.createFieldFormValue.application_data", this.createFieldFormValue.application_data);
      }

      if (this.editType == 'enrollment') {
        this.createFieldFormValue.enrollment_data = this.editLeadData.enrollment_data || {};
        this.createFieldFormValue.enrollment_data.course_id = parseInt(this.createFieldFormValue.enrollment_data.course_id || 0);
        console.log("this.createFieldFormValue.enrollment_data", this.createFieldFormValue.enrollment_data);
        this.createFieldFormValue.enrollment_data.payment_details = this.createFieldFormValue.enrollment_data.payment_details || { amount: null, payment_for: '', payment_mode: '' };
        this.createFieldFormValue.enrollment_data.payment_details.payment_date = this.createFieldFormValue.enrollment_data.payment_details?.payment_date ? new Date(this.createFieldFormValue.enrollment_data.payment_details?.payment_date) : null;
      }

    }
  }

  cities = [
    { name: 'New York', code: 'NY' },
    { name: 'Los Angeles', code: 'LA' },
    { name: 'Chicago', code: 'CH' }
  ];


  onPaymentForChange(event: any) {
    console.log("Payment For Changed:", event);
    console.log("paymentForList:", this.paymentForList);
    // make amount
    this.createFieldFormValue.enrollment_data.payment_details.amount = this.paymentForList.find((item: any) => item.value === event)?.total_fees || null;
  }

  submitForm(isValid: any) {


    this.isSubmitted = true;

    if (!isValid) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all the required fields' });
      return;
    }

    this.isLoading = true;
    this.createFieldFormValue.dynamic_fields = this.fieldValues;

    this.createFieldFormValue.old_lead_data = this.previousLeadData;

    this.createFieldFormValue.user_id = this.localStorage.getUserId();
    this.createFieldFormValue.user = this.localStorage.getUser();

    if (this.editType == 'registration') {
      this.createFieldFormValue.reg_data = {
        ...this.previousLeadData.reg_data,
        ...this.createFieldFormValue.reg_data
      }
    }

    if (this.editType == 'application') {

      console.log("updateApplicationNeeded", this.previousLeadData.application_data);
      console.log("updateApplicationNeeded", this.createFieldFormValue.application_data);

      const updateApplicationNeeded = this.previousLeadData.application_data?.status !== this.createFieldFormValue.application_data?.status || this.previousLeadData.application_data?.assign_to !== this.createFieldFormValue.application_data?.assign_to ||
        this.previousLeadData.application_data?.course_id !== this.createFieldFormValue.application_data?.course_id ||
        this.previousLeadData.application_data?.remarks !== this.createFieldFormValue.application_data?.remarks

      console.log("updateApplicationNeeded", updateApplicationNeeded);
      const updateCalls = [];

      const payload2 = {
        organization_id: this.localStorage.getOrganizationId(),
        application_id: [this.createFieldFormValue.application_data.application_id],
        status: this.createFieldFormValue.application_data.status,
        assign_to: this.createFieldFormValue.application_data.assign_to,
        course_id: this.createFieldFormValue.application_data.course_id,
        remarks: this.createFieldFormValue.application_data.remarks,
        user_id: this.localStorage.getUserId(),
        old_data: this.previousLeadData.application_data,
        new_data: {
          ...this.createFieldFormValue.application_data,
          assignedUser: this.fullUserList.find((user: any) => user.user_id === this.createFieldFormValue.application_data?.assign_to) || this.previousLeadData.application_data?.assignedUser,
          course: this.fullCourseList.find((course: any) => course.course_id === this.createFieldFormValue.application_data?.course_id) || this.previousLeadData.application_data?.course
        },
        lead_id: this.createFieldFormValue.lead_id
      };

      if (updateApplicationNeeded) {
        updateCalls.push(
          this.api.updateApplication(payload2).pipe(
            catchError(error => {
              console.log('Error updating application:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update application.' });
              return of(null); // continue with other requests
            })
          )
        );
      }

      if (true) {
        updateCalls.push(
          this.api.updateLead(this.createFieldFormValue).pipe(
            catchError(error => {
              console.log('Error updating lead:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update lead.' });
              return of(null);
            })
          )
        );
      }

      if (updateCalls.length > 0) {
        forkJoin(updateCalls).subscribe({
          next: (responses) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Updated Successfully' });
            this.handleUpdateData.emit(
              this.createFieldFormValue
            );
            this.leadActivityService.getAllLeadTimeLineActivity(this.createFieldFormValue.lead_id);
            const { old_lead_data, ...restData } = this.createFieldFormValue;
            this.previousLeadData = restData;
            // this.createFieldFormValue = {};
            // this.fieldValues = {};
            // this.previousLeadData = {};
            this.isSubmitted = false;

          },
          error: (err) => {
            // This shouldn't trigger often since we catch errors inside
            console.log('Unexpected error:', err);
            this.isLoading = false;
            this.isSubmitted = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
          }
        });
      } else {
        this.isLoading = false;
        this.isSubmitted = false;
      }

      return;

    }


    if (this.editType == 'enrollment') {

      console.log("updateEnrollmentNeeded", this.previousLeadData.enrollment_data);
      console.log("updateEnrollmentNeeded", this.createFieldFormValue.enrollment_data);

      // enrollment_status course_id assign_to
      const updateEnrollmentNeeded = this.createFieldFormValue.enrollment_data?.enrollment_status !== this.previousLeadData.enrollment_data?.enrollment_status || this.createFieldFormValue.enrollment_data?.course_id !== this.previousLeadData.enrollment_data?.course_id || this.createFieldFormValue.enrollment_data?.assign_to !== this.previousLeadData.enrollment_data?.assign_to || this.createFieldFormValue.enrollment_data?.document_status !== this.previousLeadData.enrollment_data?.document_status || this.createFieldFormValue.enrollment_data?.mode_of_study !== this.previousLeadData.enrollment_data?.mode_of_study || this.createFieldFormValue.enrollment_data?.payment_details?.payment_mode !== this.previousLeadData.enrollment_data?.payment_details?.payment_mode || this.createFieldFormValue.enrollment_data?.payment_details?.payment_for !== this.previousLeadData.enrollment_data?.payment_details?.payment_for || this.createFieldFormValue.enrollment_data?.payment_details?.amount !== this.previousLeadData.enrollment_data?.payment_details?.amount || this.createFieldFormValue.enrollment_data?.payment_status !== this.previousLeadData.enrollment_data?.payment_status || this.createFieldFormValue.enrollment_data?.payment_details?.payment_date !== this.previousLeadData.enrollment_data?.payment_details?.payment_date || this.createFieldFormValue.enrollment_data?.remarks !== this.previousLeadData.enrollment_data?.remarks

      const updateCalls = [];

      if (updateEnrollmentNeeded) {

        console.log("fullCourseList", this.fullCourseList);

        const payload2 = {
          ...this.createFieldFormValue.enrollment_data,
          organization_id: this.localStorage.getOrganizationId(),
          enrollment_id: [this.createFieldFormValue.enrollment_data.enrollment_id],
          user_id: this.localStorage.getUserId(),
          old_data: {
            ...this.previousLeadData.enrollment_data,
            assignedUser: this.fullUserList.find((user: any) => user.user_id === this.previousLeadData.enrollment_data?.assign_to) || this.previousLeadData.enrollment_data?.assignedUser,
            course: this.fullCourseList.find((course: any) => course.course_id === this.previousLeadData.enrollment_data?.course_id) || this.previousLeadData.enrollment_data?.course,
            payment_details: this.previousLeadData.enrollment_data?.payment_details
          },
          new_data: {
            ...this.createFieldFormValue.enrollment_data,
            assignedUser: this.fullUserList.find((user: any) => user.user_id === this.createFieldFormValue.enrollment_data?.assign_to) || this.previousLeadData.enrollment_data?.assignedUser,
            course: this.fullCourseList.find((course: any) => course.course_id === this.createFieldFormValue.enrollment_data?.course_id) || this.previousLeadData.enrollment_data?.course,
            payment_details: this.createFieldFormValue.enrollment_data?.payment_details
          },
          lead_id: this.createFieldFormValue.lead_id
        };

        updateCalls.push(
          this.api.updateEnrollment(payload2).pipe(
            catchError(error => {
              console.log('Error updating enrollment:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update enrollment.' });
              return of(null);
            })
          )
        );
      }

      if (true) {
        updateCalls.push(
          this.api.updateLead(this.createFieldFormValue).pipe(
            catchError(error => {
              console.log('Error updating lead:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update lead.' });
              return of(null);
            })
          )
        );
      }

      if (updateCalls.length > 0) {
        forkJoin(updateCalls).subscribe({
          next: (responses) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Updated Successfully' });
            this.handleUpdateData.emit(
              this.createFieldFormValue
            );
            this.leadActivityService.getAllLeadTimeLineActivity(this.createFieldFormValue.lead_id);
            const { old_lead_data, ...restData } = this.createFieldFormValue;
            this.previousLeadData = restData;
            this.previousLeadData.enrollment_data = {
              ...this.previousLeadData.enrollment_data,
              assignedUser: this.fullUserList.find((user: any) => user.user_id === this.previousLeadData.enrollment_data?.assign_to) || this.previousLeadData.enrollment_data?.assignedUser,
              payment_details: JSON.parse(JSON.stringify(this.previousLeadData.enrollment_data?.payment_details))
            };
            console.log(" previousLeadData", this.previousLeadData)
            // this.createFieldFormValue = {};
            // this.fieldValues = {};
            // this.previousLeadData = {};
            this.isSubmitted = false;

          },
          error: (err) => {
            // This shouldn't trigger often since we catch errors inside
            console.log('Unexpected error:', err);
            this.isLoading = false;
            this.isSubmitted = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
          }
        });
      } else {
        this.isLoading = false;
        this.isSubmitted = false;
      }

      return;

    }



    console.log("Updating lead with data:", this.createFieldFormValue);

    this.api.updateLead(this.createFieldFormValue).subscribe({
      next: (c) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Updated Successfully' });
        this.handleUpdateData.emit(
          this.createFieldFormValue
        );
        this.leadActivityService.getAllLeadTimeLineActivity(this.createFieldFormValue.lead_id);
        const { old_lead_data, ...restData } = this.createFieldFormValue;
        this.previousLeadData = restData;
        console.log(" previousLeadData", this.previousLeadData)
        // this.createFieldFormValue = {};
        // this.fieldValues = {};
        // this.previousLeadData = {};
        this.isSubmitted = false;

      },
      error: (e) => {
        this.isLoading = false;
        this.isSubmitted = false;
        console.log('Error occurred:', e);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
      },
      complete: () => { },
    });

  }

  onTabChange(event: any) {
    console.log('Tab Changed:', event);
    this.activeTab = event;
    this.changeTab.emit(event);
  }

  managePipeline() {
    this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
  }

}
